import styles from './index.module.scss';
import Queue from './pages/queue';
import TopClients from './pages/topClients';
import TotPren from './pages/totPren';
import RandomType from './pages/RandomType';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { useRef, useState } from 'react';
import 'swiper/css';
import { ReactComponent as ArrowLIcon } from '../../../../assets/svg/icons/arrow_l.svg';
import { ReactComponent as ArrowRIcon } from '../../../../assets/svg/icons/arrow_r.svg';
import { ReactComponent as CloseIcon } from '../../../../assets/svg/icons/chiudi.svg';
import { modalActions } from 'Containers/Modals/store';
import { useDispatch } from 'react-redux';

const NavigationButtons = () => {
    const swiper = useSwiper();
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    swiper.on('slideChange', () => {
        setIsBeginning(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
    });

    return (
        <div className={styles.navigation_buttons}>
            <button
                className={styles.nav_button}
                onClick={() => swiper.slidePrev()}
                disabled={isBeginning}
            >
                <ArrowLIcon />
            </button>
            <button
                className={styles.nav_button}
                onClick={() => swiper.slideNext()}
                disabled={isEnd}
            >
                <ArrowRIcon />
            </button>
        </div>
    );
};

const WrappedModal = ({wrappedStats}) => {
    console.log("wrappedStats", wrappedStats);
    const dispatch = useDispatch();

    return (
        <div className={styles.container}>
            <section className={styles.header}>
                <div className={styles.header_content}>
                    <h1 className={styles.title}>Il tuo anno con ZetaBarber</h1>
                    <p className={styles.subtitle}>{"Scopri i risultati di quest'anno!"} <br/> {"Scorri le card per scoprire i risultati ottenuti, fai lo screen e condividilo con tutti sui social!"}</p>
                </div>
                <CloseIcon style={{width: 30, height: 30}} onClick={() => {
                    dispatch(modalActions.CLOSE_MODAL.SUCCESS())
                    localStorage.setItem('wrappedStats', true);
                }}/>
            </section>
            <section className={styles.content}>
                <Swiper
                    slidesPerView={1}
                    spaceBetween={0}
                    className={styles.carousel}
                >
                    {wrappedStats?.allPren >100 &&<SwiperSlide>
                        <TotPren totalPren={wrappedStats?.allPren || 0}/>
                    </SwiperSlide>}
                    {wrappedStats?.bestUser?.length > 0 &&<SwiperSlide>
                        <TopClients topClients={wrappedStats?.bestUser || []}/>
                    </SwiperSlide>}
                    {wrappedStats?.allQueue > 100 &&<SwiperSlide>
                        <Queue queue={{
                            queue: wrappedStats?.allQueue,
                            bestDay: wrappedStats?.bestDay
                        }}/>
                    </SwiperSlide>}
                    <SwiperSlide>
                        <RandomType/>
                    </SwiperSlide>
                    <NavigationButtons />
                </Swiper>
            </section>
        </div>
    );
}

export default WrappedModal;

